export default __webpack_public_path__ + "static/media/logo.4859d95e.png";